import { bucketStatus } from "@workspace/schemas/drizzle/buckets";
import type { Bucket } from "@workspace/schemas/zod";

const BUCKET_END_WARNING_LEAD_MS = 5 * 60_000;

export const BUCKET_END_WARNING_TEXT = {
  TITLE: "Bucketende steht bevor",
  BODY: "Das geplante Ende dieses Buckets steht in Kürze bevor. Bitte schließe den Task zeitnah ab und beende den Bucket.",
  OKAY: "Okay",
} as const;

/** Same tag for the same bucket, so the browser collapses repeats into one notification. */
export function bucketEndNotificationTag(bucketId: number) {
  return `bucket-end-${bucketId}`;
}

/** Milliseconds until the warning should fire; 0 when due now; null when the bucket is not in progress. */
export function bucketEndWarningDelayMs(bucket: Pick<Bucket, "status" | "plannedEndTime">, now = new Date()) {
  if (bucket.status !== bucketStatus.IN_PROGRESS) return null;
  return Math.max(0, bucket.plannedEndTime.getTime() - BUCKET_END_WARNING_LEAD_MS - now.getTime());
}

/** Browsers only show the prompt inside a user gesture, so call this from a click handler. */
export function requestBucketEndNotificationPermission() {
  if (typeof Notification === "undefined" || Notification.permission !== "default") return;
  void Notification.requestPermission();
}
